import Header from '../home/header.js';
import Hero from '../home/hero';
import About from '../home/about';
import Services from '../home/services';
import Parallaxview from '../home/parallaxview.js';
import Contactnow from '../home/contactnow';
import Faq from '../home/faq';
import ServiceDescription from '../home/servicesDescription';
import Technologies from '../home/technologies';
import Testimonials from '../home/testimonial';
import HowwebuildProject from '../home/howwebuildProject';
import Footer from '../home/footer';
import Blog from './blog.js';
import Portfolio from './portfolio.js';
import Packages from './packages.js';
import ProcessTimeline from './ProcessTimeLine.js';
import Dreamcontact from './dreamcontact.js';
import Indestry from './indestry.js';
const home=()=>{
    return(
        <>
            <Header/>
            <Hero/>
            <About/>
            {/* <Parallaxview/> */}
            <Services/>
            <ServiceDescription/>
            <Technologies/>
            <Indestry/>
            <HowwebuildProject/>
            {/* <ProcessTimeline/> */}
            <Portfolio/>
            {/* <Blog/> */}
            <Testimonials/>
            <Faq/>
            <Packages/>
            {/* <Contactnow/> */}
            <Dreamcontact/>
            <Footer/>
        </>
    )
}

export default home